import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import * as util from "../../utils/util";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Top from "../Top";
import Bottom from "../Bottom";
import Card from "@mui/material/Card";
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';


const GeneticResult = () => {
  //유전자 결과
  const [geneticTestResultList, setGeneticTestResultList] = useState([]);
  const [geneticTestResult, setGeneticTestResult] = useState([]);
  //년도설정
  const [year, setYear] = useState('');
  //검사결과가 존재하는 년도리스트
  const [yearList, setYearList] = useState([]);
  // 이름 초기값은 로그인 시 저장해 둔 localStorage.userName (MoreInfo 와 같은 이유 —
  // 무조건 '비회원'으로 시작하면 조회가 끝날 때까지 로그인 사용자도 '비회원'으로 보인다)
  const [memberName, setMemberName] = React.useState(
    () => util.strNull(window.localStorage.userName) || '비회원',
  );

  useEffect(() => {

    api.get('permission/getProfile').then((res: any) => {
      // 빈 값으로 덮어쓰면 저장된 이름까지 지워진다 — 값이 있을 때만 갱신한다
      const name = util.strNull(res?.data?.name);
      if (name !== '') setMemberName(name);
    }).catch(function (error: any) {
      console.log(error)
    });

    const userCusID = localStorage.getItem('userCusID') || '';
    api.post('customer/api/v1/getGeneticTestResult', { customerId: userCusID }).then(res => {
      if (res.data.message === "SUCCESSS" && Array.isArray(res.data.data.yearList) && res.data.data.yearList.length > 0) {
        setYear(res.data.data.yearList[0]);
        setYearList(res.data.data.yearList);
        setGeneticTestResultList(res.data.data.geneticTestResultDTOList);
        setGeneticTestResult(res.data.data.geneticTestResultDTOList.filter((v: any) => v.year === res.data.data.yearList[0]));
      } else {
        // @ts-ignore
        setYearList(['없음']);
        setYear("없음");
      }

    }).catch(function (error) {
      console.log(error)
    });

  }, []);

  // 연도 변경 이벤트
  const handleChangeYaer = (e: any) => {
    setYear(e.target.value);
    setGeneticTestResult(geneticTestResultList.filter((v: any) => v.year === e.target.value));
  };

  //속성명 변환
  const translateKeyToKorean = (key: string) => {
    const translations: { [key: string]: string } = {
      bloodPressure: '혈압',
      bloodSugar: '혈당',
      ldl: 'LDL',
      hdl: 'HDL',
      obesity: '비만',
      triglycerideLevel: '중성지방농도',
      osteoarthritisSusceptibility: '퇴행성관절염중감수성',
      abdominalObesity: '복부비만',
      alcoholMetabolism: '알코올 대사',
      boneDensity: '골질량',
      // 다른 속성들에 대한 번역 추가
    };
    return translations[key];
  };

  function getGeneticResultCololr(status: any) {
    switch (status) {
      case '양호':
        return '#8bc34a';
      case '경계':
        return '#ff9800';
      case '주의':
        return '#f44336';
      default:
        return '#999';
    }
  }



  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 7, pb: 12, pl: 2, pr: 2, minWidth: 320 }}>
      <Top title='유전자검사 결과' />


      <Card sx={{ borderRadius: 3, mt: 4, p: 2, }}>
        {/* <Stack direction={'row'} >
            <Typography sx={{ fontSize: 16, fontWeight: 700 }}>검진결과 내역</Typography>
            <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#555', ml: 'auto' }} />
          </Stack>
          <Divider sx={{ mt: 1, mb: 1.5 }} /> */}

        <Stack direction={'column'} justifyContent={'space-evenly'} alignItems={'center'}>
          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{memberName}<Typography component={'span'} sx={{ fontSize: 14 }}> 님의 유전자검사 결과 </Typography></Typography>
        </Stack>
      </Card>

      <Box sx={{ m: 2, ml: 0, }}>
        <FormControl >

          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={year}
            onChange={handleChangeYaer}
            sx={{
              border: 'none', bgcolor: '#fff', fontSize: 14, borderRadius: 8, width: 90,
              '& fieldset': { borderColor: '#ddd' }
            }}
          >
            {yearList.map((rg: any, index: any) => (
              <MenuItem value={rg}>{rg}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {geneticTestResult.length <= 0 ? (
         <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
        <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
         <Typography sx={{ fontSize: 16, color: '#888' }} >유전자검사 결과 정보가 없습니다.</Typography>
    
       </Stack>
     ) : (
 
        geneticTestResult[0] && Object.entries(geneticTestResult[0]).map((key: any, idx: any) => (
          key[0] !== 'year' && key[0] !== 'customerId' && key[0] !== 'inspectionDate' && key[0] !== 'id' ? (
  
            <Card sx={{  px: 2, py: 2, mb:1.5 }}>
              <React.Fragment>
                <Stack direction={'row'} alignItems={'center'} >
                  <Typography sx={{ fontSize: 16, color: '#555', }}>{translateKeyToKorean(key[0])}</Typography>
                  <Typography sx={{ fontSize: 16, color: '#fff', fontWeight: 700, ml: 'auto', borderRadius: 5, bgcolor: getGeneticResultCololr(key[1]), px: 2, py: .5 }}>{key[1]}</Typography>
                </Stack>
              </React.Fragment>
              </Card>
          ) : null
      
        ))
      )}
    

      <Bottom />
    </Container>
  );
}

export default GeneticResult;